import React from "react";
import { Link } from "react-router-dom";
import "../styles/Footer.css";

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-container justify-content-center text-center">
        {/* Disclaimer */}
        <p className="footer-disclaimer">
          Ebben a véleménynyilvánításban kifejtett eredmények nem tipikusak, és
          az illető személyes véleményét és szubjektív tapasztalatait tükrözik.
          Az egyéni eredmények változóak lehetnek. A Forever nem vállal
          garanciát a bevételre, illetve a sikerre. További információért
          kérjük, tekintsd meg a Forever éves jövedelemnyilatkozatát a{" "}
          <a
            href="https://foreverliving.com/income"
            target="_blank"
            rel="noopener noreferrer"
          >
            foreverliving.com/income
          </a>{" "}
          oldalon.
        </p>

        <div className="footer-bottom">
          <p className="footer-rights">
            © {new Date().getFullYear()} Minden jog fenntartva.
          </p>

          <div className="footer-links">
            <Link to="/impressum">Impresszum</Link>
            <span className="divider">|</span>
            <Link to="/adatvedelem">Adatkezelési tájékoztató</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
